import p1 from "../../assets/productsAsset/p1.webp";
import p2 from "../../assets/productsAsset/p2.webp";
import p3 from "../../assets/productsAsset/p3.webp";
import p4 from "../../assets/productsAsset/p4.webp";
import p5 from "../../assets/productsAsset/p5.webp";
import p6 from "../../assets/productsAsset/p6.webp";
import p7 from "../../assets/productsAsset/p7.webp";
import p8 from "../../assets/productsAsset/p8.webp";
import p9 from "../../assets/productsAsset/p9.webp";
import p10 from "../../assets/productsAsset/p10.webp";
import p11 from "../../assets/productsAsset/p11.webp";
import p12 from "../../assets/productsAsset/p12.webp";
import p13 from "../../assets/productsAsset/p13.webp";
import p14 from "../../assets/productsAsset/p14.webp";
import p15 from "../../assets/productsAsset/p15.webp";
import p16 from "../../assets/productsAsset/p16.webp";
import p17 from "../../assets/productsAsset/p17.webp";
import p18 from "../../assets/productsAsset/p18.webp";
import p19 from "../../assets/productsAsset/p19.webp";
import p20 from "../../assets/productsAsset/p20.webp";
import p21 from "../../assets/productsAsset/p21.webp";
import p22 from "../../assets/productsAsset/p22.webp";
import p23 from "../../assets/productsAsset/p23.webp";
import p24 from "../../assets/productsAsset/p24.webp";
import p25 from "../../assets/productsAsset/p25.webp";
import p26 from "../../assets/productsAsset/p26.webp";
import p27 from "../../assets/productsAsset/p27.webp";
import p28 from "../../assets/productsAsset/p28.webp";
import thp1 from "../../assets/productsAsset/thp1.webp";
import thp2 from "../../assets/productsAsset/thp2.webp";
import thp3 from "../../assets/productsAsset/thp3.webp";
import thp4 from "../../assets/productsAsset/thp4.webp";
import thp5 from "../../assets/productsAsset/thp5.webp";
import thp6 from "../../assets/productsAsset/thp6.webp";
import thp7 from "../../assets/productsAsset/thp7.webp";
import thp8 from "../../assets/productsAsset/thp8.webp";
import thp9 from "../../assets/productsAsset/thp9.webp";
import thp10 from "../../assets/productsAsset/thp10.webp";
import thp11 from "../../assets/productsAsset/thp11.webp";
import thp12 from "../../assets/productsAsset/thp12.webp";
import thp13 from "../../assets/productsAsset/thp13.webp";
import thp14 from "../../assets/productsAsset/thp14.webp";
import thp15 from "../../assets/productsAsset/thp15.webp";
import thp16 from "../../assets/productsAsset/thp16.webp";
import thp17 from "../../assets/productsAsset/thp17.webp";
import thp18 from "../../assets/productsAsset/thp18.webp";
import thp19 from "../../assets/productsAsset/thp19.webp";
import thp20 from "../../assets/productsAsset/thp20.webp";
import thp21 from "../../assets/productsAsset/thp21.webp";
import thp22 from "../../assets/productsAsset/thp22.webp";
import thp23 from "../../assets/productsAsset/thp23.webp";
import thp24 from "../../assets/productsAsset/thp24.webp";
import thp25 from "../../assets/productsAsset/thp25.webp";
import thp26 from "../../assets/productsAsset/thp26.webp";
import thp27 from "../../assets/productsAsset/thp27.webp";
import thp28 from "../../assets/productsAsset/thp28.webp";
import thp29 from "../../assets/productsAsset/thp29.webp";
import thp30 from "../../assets/productsAsset/thp30.webp";
import al1 from "../../assets/productsAsset/al1.webp";
import al2 from "../../assets/productsAsset/al2.webp";
import al3 from "../../assets/productsAsset/al3.jpg";
import al4 from "../../assets/productsAsset/al4.webp";
import al5 from "../../assets/productsAsset/al5.webp";
import al6 from "../../assets/productsAsset/al6.webp";
import al7 from "../../assets/productsAsset/al7.webp";
import al8 from "../../assets/productsAsset/al8.jpg";
import al9 from "../../assets/productsAsset/al9.webp";
import al10 from "../../assets/productsAsset/al10.webp";
import al11 from "../../assets/productsAsset/al11.webp";
import al12 from "../../assets/productsAsset/al12.webp";
import al13 from "../../assets/productsAsset/al13.webp";
import al14 from "../../assets/productsAsset/al14.webp";
import al15 from "../../assets/productsAsset/al15.webp";
const printsData = [
  {
    id: 1,
    title: "Golden Radiance",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p1,
  },
  // {
  //   id: 1221,
  //   title: "Test Product",
  //   category: "Abstract",
  //   price: 0.99,
  //   image: p1,
  // },
  {
    id: 2,
    title: "Ember Storm",
    category: "Abstract",
    pieces: "1piece",
    price: 89.99,
    image: p2,
  },
  {
    id: 3,
    title: "Celestial Awakening",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p3,
  },
  {
    id: 4,
    title: "Lake Sunrise",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p4,
  },
  {
    id: 5,
    title: "Gold and Blue Art",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p5,
  },
  {
    id: 6,
    title: "Gold Feather",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p6,
  },
  {
    id: 7,
    title: "Brown and Gray Swirls",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p7,
  },

  {
    id: 11,
    title: "Blue Gold Flow",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p11,
  },
  {
    id: 1432,
    title: "Emerald Gold Swirl",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p12,
  },
  {
    id: 213,
    title: "Soft Color Strokes",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p13,
  },
  {
    id: 14,
    title: "Ink Cloud Art",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p14,
  },
  {
    id: 15,
    title: "Textured Color Patches",
    category: "Abstract",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p15,
  },
  {
    id: 41,
    title: "Orange Tree",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p16,
  },
  {
    id: 42,
    title: "Rasta Flying",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p17,
  },
  {
    id: 43,
    title: "Beautiful Meaning",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p18,
  },
  {
    id: 44,
    title: "Luxe Flower Abstract",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p19,
  },
  {
    id: 45,
    title: "Together Lion Family",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p20,
  },
  {
    id: 46,
    title: "Horse Portrait",
    category: "Wall Art",
    price: 89.99,
    pieces: "1piece", // ✅
    image: p21,
  },
  {
    id: 47,
    title: "Old Three",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: p23,
  },
  {
    id: 48,
    title: "Side View",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p22,
  },
  {
    id: 47,
    title: "Muslim One",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p24,
  },
  {
    id: 49,
    title: "Old Spot",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p25,
  },
  {
    id: 50,
    title: "Yellow Age",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p26,
  },
  {
    id: 47,
    title: "Overthinking",
    pieces: "1piece", // ✅
    category: "Wall Art",
    price: 89.99,
    image: p27,
  },
  {
    id: 47,
    title: "Red World",
    category: "Wall Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: p28,
  },
  {
    id: 53,
    title: "Three Gold Foil Flowers",
    category: "Three Panels",
    pieces: "3pieces", // ✅

    price: 89.99,
    image: thp1,
  },
  {
    id: 12,
    title: "Wood Effect",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp2,
  },
  {
    id: 13,
    title: "Different Leafs",
    category: "Three Panels",
    price: 89.99,
    pieces: "3pieces", // ✅
    image: thp3,
  },
  {
    id: 14,
    title: "Green & Gold Feathers",
    category: "Three Panels",
    price: 89.99,
    pieces: "3pieces", // ✅
    image: thp4,
  },
  {
    id: 15,
    title: "Gold World Map",
    category: "Three Panels",
    price: 89.99,
    pieces: "3pieces", // ✅
    image: thp5,
  },
  {
    id: 16,
    title: "Purple Era",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp6,
  },
  {
    id: 17,
    title: "Art of Brush",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp7,
  },
  {
    id: 18,
    title: "Escaping Objects",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp8,
  },
  {
    id: 19,
    title: "Strokes Left",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp9,
  },
  {
    id: 20,
    title: "Gold Foil Flowers",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp10,
  },
  {
    id: 21,
    title: "Womens Abstract Minimal",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp11,
  },
  {
    id: 22,
    title: "Three Abstract Rainbow",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp12,
  },
  {
    id: 23,
    title: "Purple World",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp13,
  },
  {
    id: 24,
    title: "Three Panel Flower",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp14,
  },
  {
    id: 25,
    title: "Three Season Three",
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp15,
  },
  {
    id: 26,
    title: "Way Gold", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp16,
  },
  {
    id: 27,
    title: "White Era", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp17,
  },
  {
    id: 28,
    title: "Floating Boat", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp18,
  },
  {
    id: 29,
    title: "Into Deep", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp19,
  },
  {
    id: 30,
    title: "Leafs of Wind", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp20,
  },
  {
    id: 31,
    title: "Green & Gold World Map", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp21,
  },
  {
    id: 32,
    title: "Escaping Balls", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp22,
  },
  {
    id: 33,
    title: "Monstera", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp23,
  },
  {
    id: 34,
    title: "Crystals", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp24,
  },
  {
    id: 35,
    title: "Leaf Lines", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp25,
  },
  {
    id: 36,
    title: "Water in Gold", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp26,
  },
  {
    id: 37,
    title: "Blue Gold Abstract", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp27,
  },
  {
    id: 38,
    title: "Golden Lines", // Replace with actual title
    category: "Three Panels",
    price: 89.99,
    image: thp28,
  },
  {
    id: 39,
    title: "Grey Neon Abstract", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp29,
  },
  {
    id: 40,
    title: "Yellow Abstract", // Replace with actual title
    category: "Three Panels",
    pieces: "3pieces", // ✅
    price: 89.99,
    image: thp30,
  },
  {
    id: 26,
    title: "Isa Boletini",
    category: "Albanian Art",
    price: 89.99,
    pieces: "1piece", // ✅
    image: al1,
  },
  {
    id: 27,
    title: "Veshje Popullore",
    category: "Albanian Art",
    price: 89.99,
    pieces: "1piece", // ✅
    image: al2,
  },
  {
    id: 28,
    title: "Ibrahim Rugova",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al3,
  },
  {
    id: 29,
    pieces: "1piece", // ✅
    title: "Fytyra Atdhetare",
    category: "Albanian Art",
    price: 89.99,
    image: al4,
  },
  {
    id: 30,
    title: "Veshja te vjetra v2",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al5,
  },
  {
    id: 31,
    title: "Luftetaret v1",
    pieces: "1piece", // ✅
    category: "Albanian Art",
    price: 89.99,
    image: al6,
  },
  {
    id: 32,
    title: "Adem Jashari",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al7,
  },
  {
    id: 33,
    title: "Fehmi dhe Xheve Lladrovci",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al8,
  },
  {
    id: 34,
    title: "Fytyra Atdhetare v2",
    pieces: "1piece", // ✅
    category: "Albanian Art",
    price: 89.99,
    image: al9,
  },
  {
    id: 35,
    title: "Nena Tereze",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al10,
  },
  {
    id: 36,
    title: "Azem Galica",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al11,
  },
  {
    id: 37,
    title: "Kulla e Prizrenit",
    pieces: "1piece", // ✅
    category: "Albanian Art",
    price: 89.99,
    image: al12,
  },
  {
    id: 38,
    title: "Fshat i vjeter shqipetar",
    pieces: "1piece", // ✅
    category: "Albanian Art",
    price: 89.99,
    image: al13,
  },
  {
    id: 39,
    title: "Veshje e vjeter femrore",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al14,
  },
  {
    id: 40,
    title: "Lufta e Xhelave",
    category: "Albanian Art",
    pieces: "1piece", // ✅
    price: 89.99,
    image: al15,
  },
];
function getProductData(id) {
  var productData = printsData.find((product) => product.id === id);
  if (productData === undefined) {
    console.log("NOT EXISTS" + id);
    return undefined;
  }
  return productData;
}

export { printsData, getProductData };
